import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import {
  ButtonsContainer,
  TabContainer,
} from "../move-inRegistrationTabs/move-inTabs.styled";
import { Table } from "../MoveOutTerminationTabs/MoveOut.styled";
import { FC, ReactElement } from "react";
import { FeesAndChargesNOCProps } from "../move-inRegistrationTabs/interfaces";
import { padding } from "@mui/system";
import General from '../../stores/GeneralStore'
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { toJS } from "mobx";
import { Spinner } from "../SpinnerRaw/SpinnerRaw";
const FeesAndChargesNOC: FC<FeesAndChargesNOCProps> = ({ Previous, connectionFees, serviceCharges, tenantFeeDues, nocCharge, onClick, isId, deliveryCharge, postNOCDuePropertyCount,duesLoader}: FeesAndChargesNOCProps): ReactElement => {
  const navigate = useNavigate()
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  const maskName = (name: string = "") => {
  const parts = name
    ?.split(" ")
    .filter(Boolean); // remove empty strings

  const firstName = parts[0] || "";
  const lastName = parts[parts.length - 1] || "";

  const mask = (str: string) => {
    if (str.length <= 2) return str; // no masking if too short
    return str.substring(0, 2) + "*".repeat(Math.max(0, str.length - 2));
  };

  return `${mask(firstName)} ${mask(lastName)}`;
};

  return (
    <>
      {duesLoader?<Spinner />:
        <TabContainer>
        {/* <h2 style={{
          fontFamily: "Segoe UI",
          fontStyle: "normal",
          fontSize: `${1.56 * General.accessibility.fontSize}rem`,
          fontWeight: "700",
          padding: '1rem 0rem',
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
        }}>
          {General?.codeLabels["cm_noc_owned"]?.label ? General?.codeLabels["cm_noc_owned"]?.label : 'NOC for Owned Plot'}
        </h2> */}
        {(isId && nocCharge?.customerName != null) && <h4 style={{
          fontFamily: "Segoe UI",
          fontStyle: "normal",
          fontSize: `${1 * General.accessibility.fontSize}rem`,
          fontWeight: "700",
          padding: '0rem 0rem',
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
        }}>
          {General?.codeLabels['cm_ownername']?.label ? General?.codeLabels['cm_ownername']?.label : "Owner Name"}&nbsp;{maskName(nocCharge?.customerName)}
        </h4>}

        <Table beforeLastChild={true} >
          <thead>
            <tr>
              <th style={{ textAlign: "start", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>
                {General?.codeLabels["cm_description"]?.label !== undefined ? General?.codeLabels["cm_description"]?.label : "Description"}
              </th>
              <th style={{ textAlign: "center", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>
                {General?.codeLabels["cm_propertycount"]?.label !== undefined ? General?.codeLabels["cm_propertycount"]?.label : "Property Count"}
              </th>
              <th style={{ textAlign: "end", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>
                {General?.codeLabels["cm_dueamt"]?.label !== undefined ? General?.codeLabels["cm_dueamt"]?.label : "Due Amount"}(AED)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ textAlign: "start", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{General?.codeLabels["cm_noctenantfee"]?.label !== undefined ? General?.codeLabels["cm_noctenantfee"]?.label : "cm_noctenantfee"}</td>
              <td style={{ textAlign: "center", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{isId ? postNOCDuePropertyCount?.tenantPropertyCount : tenantFeeDues?.count}</td>
              <td style={{ textAlign: "end", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{isId ? new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(nocCharge?.tenantFee)) : new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(tenantFeeDues?.amount))}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "start", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{General?.codeLabels["cm_nocconnfee"]?.label !== undefined ? General?.codeLabels["cm_nocconnfee"]?.label : "Connection Fees"}</td>
              <td style={{ textAlign: "center", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{isId ? postNOCDuePropertyCount?.connectionPropertyCount : (connectionFees?.count)}</td>
              <td style={{ textAlign: "end", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{isId ? new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(nocCharge?.connectionFees)) : new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(connectionFees?.amount))}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "start", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{General?.codeLabels["cm_nocdeliveryfee"]?.label !== undefined ? General?.codeLabels["cm_nocdeliveryfee"]?.label : "Delivery Charge"}</td>
              <td style={{ textAlign: "center", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{isId ? postNOCDuePropertyCount?.deliveryPropertyCount ? postNOCDuePropertyCount?.deliveryPropertyCount : 0 : (deliveryCharge?.count)}</td>
              <td style={{ textAlign: "end", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{deliveryCharge?.count ? new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(deliveryCharge?.amount)) : 0}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "start", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{General?.codeLabels["cm_nocf_svce"]?.label !== undefined ? General?.codeLabels["cm_nocf_svce"]?.label : "Service Fees"}</td>
              <td style={{ textAlign: "center", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{isId ? postNOCDuePropertyCount?.servicePropertyCount : (serviceCharges?.count)}</td>
              <td style={{ textAlign: "end", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{isId ? new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(nocCharge?.serviceFees)) : new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(serviceCharges?.amount))}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "start", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{General?.codeLabels["cm_noc_charges"]?.label ? General?.codeLabels["cm_noc_charges"]?.label : "NOC Charges"}</td>
              <td style={{ textAlign: "center", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{isId ? postNOCDuePropertyCount?.nOCPropertyCount : (nocCharge?.count)}</td>
              <td style={{ textAlign: "end", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{isId ? new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(nocCharge?.nOCCharges)) : new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(nocCharge?.amount))}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "start", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{General?.codeLabels["cm_mototalamt"]?.label !== undefined ? General?.codeLabels["cm_mototalamt"]?.label : "Total amount to be paid"}</td>
              <td style={{ textAlign: "center", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}></td>
              <td style={{ textAlign: "end", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>
                {isId ? new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(Number(nocCharge?.tenantFee) + Number(nocCharge?.connectionFees) + Number(nocCharge?.serviceFees) + Number(nocCharge?.nOCCharges))) : new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(Number(connectionFees?.amount) + Number(serviceCharges?.amount) + Number(tenantFeeDues?.amount) + Number(nocCharge?.amount)))}
              </td>
            </tr>
          </tbody>
        </Table>

        <br />
        <span style={{
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          width: "347px",
          height: "16px",
          fontFamily: 'Segoe UI',
          fontStyle: "normal",
          fontWeight: "400",
          fontSize: `${General.accessibility.fontSize}rem`,
          lineHeight: "16px",
        }}>{General?.codeLabels["cm_noc_call_charges"]?.label ? General?.codeLabels["cm_noc_call_charges"]?.label : '• All dues should be paid in order to Issue NOC'}</span>
        <br />
        <div style={{
          display: "flex",
          flexDirection: General?.isLargeScreen ? "row" : "column",
          gap: "2rem",
        }}>
          <ButtonSecondary
            style={{
              width: General?.isLargeScreen ? "168px" : "98%",
              height: "50px", fontSize: `${General.accessibility.fontSize}rem`,
              color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss,
              background: contrast?.contrastColor ? contrast?.contrastColor : '#fff',
              border: `1px solid ${contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss}`,
            }}
            onClick={Previous}
          // onClick={()=>navigate(-1)}
          >
            {General?.codeLabels["cm_back"]?.label !== undefined ? General?.codeLabels["cm_back"]?.label : "BACk"}
          </ButtonSecondary>
          <ButtonSecondary
            style={{
              width: General?.isLargeScreen ? "168px" : "98%",
              height: "50px",
              fontSize: `${General.accessibility.fontSize}rem`,
              color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", background: contrast?.contrastColor ? contrast?.contrastColor : '#101E8E',
            }}
            // onClick={()=>navigate('/dashboard')}
            onClick={onClick}
            className="InsideNocButton"
          >
            {General?.codeLabels["cm_btncontinue"]?.label !== undefined ? General?.codeLabels["cm_btncontinue"]?.label : "Continue"}
          </ButtonSecondary>
        </div>
      </TabContainer>}
    </>
  );
};

export default observer(FeesAndChargesNOC);
